module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_17.cb94dadf.pdf";